import {z} from '@hono/zod-openapi';

export const hondaCatalogPartSchema = z
  .object({
    partNumber: z.string().openapi({example: 'AART1256J00'}),
    descriptionOrReplacementPartNumber: z.string().openapi({example: 'ENGINE CRADLE'}),
    price: z.number().finite().nonnegative().openapi({example: 88681}),
    flag: z.enum(['A', 'O']),
    code: z.string().openapi({
      example: '03',
      description:
        'Honda source group code. Group tables can be incomplete; no price or vehicle classification is inferred from the code.',
    }),
    active: z.boolean(),
    batchId: z.string().openapi({description: 'Published catalog version containing this part.'}),
  })
  .openapi('HondaCatalogPart');

export type HondaCatalogPart = z.infer<typeof hondaCatalogPartSchema>;
